import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stringcheck',
  templateUrl: './stringcheck.component.html',
  styleUrls: ['./stringcheck.component.css']
})
export class StringcheckComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
